<div *ngIf="networkProfile">
  <div class="stick-top">
    <mat-toolbar
      ><mat-icon>class</mat-icon>
      {{
        networkProfile.id
          ? "Network Profile - " + networkProfile.name
          : "Create new Network Profile"
      }}</mat-toolbar
    >
    <div class="hbox lightly-padded button-bar">
      <button
        mat-raised-button
        class="primary"
        type="button"
        (click)="save()"
        [disabled]="!form.form.valid"
      >
        <mat-icon>{{ networkProfile.id ? "save" : "add" }}</mat-icon>
        {{ networkProfile.id ? "Update" : "Add" }}
      </button>
      <micro-delete-confirm
        *ngIf="networkProfile.id"
        (onConfirm)="delete()"
      ></micro-delete-confirm>
    </div>
  </div>
  <div class="padded">
    <form #form="ngForm" role="form">
      <table class="basicTable vtable">
        <thead>
          <tr>
            <th colspan="100">Network Profile Details</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="auth.isCompanyAdmin()"><th>Company</th><td><micro-company-select [(companyId)]="networkProfile.companyId" [required]="true"></micro-company-select></td></tr>
          <tr>
            <th>
              <micro-valid-label
                for="code"
                [model]="code"
                label="Code"
              ></micro-valid-label>
            </th>
            <td>
              <input
                #code="ngModel"
                [(ngModel)]="networkProfile.code"
                required
                maxlength="10"
                id="code"
                name="code"
              />
            </td>
          </tr>
          <tr>
            <th>
              <micro-valid-label
                for="name"
                [model]="name"
                label="Name"
              ></micro-valid-label>
            </th>
            <td>
              <input
                #name="ngModel"
                [(ngModel)]="networkProfile.name"
                required
                maxlength="50"
                id="name"
                name="name"
              />
            </td>
          </tr>
          <tr>
            <th>Description</th>
            <td>
              <textarea
                [(ngModel)]="networkProfile.description"
                required
                maxlength="200"
                id="description"
                name="description"
                style="min-width: 350px; min-height: 100px"
              ></textarea>
            </td>
          </tr>
          <tr>
            <th [ngClass]="networkProfile.active !== 'Y' ? 'CRITICAL' : ''">
              <micro-valid-label
                for="active"
                label="Active"
              ></micro-valid-label>
            </th>
            <td>
              <input
                type="checkbox"
                [checked]="networkProfile.active === 'Y'"
                (change)="onCheckboxChange($event)"
                id="active"
                name="active"
              />
            </td>
          </tr>
          <tr>
            <th>
              <micro-valid-label
                for="hostingPlatformName"
                [model]="hostingPlatformName"
                label="Hosting Platform"
              ></micro-valid-label>
            </th>
            <td>
              <micro-select-pagination
                apiUrl="/domain/cmdbHostingPlatform"
                [(id)]="networkProfile.hostingPlatformId"
                [defaultOption]="selectedHostingPlatform"
                placeholder="Hosting Platform"
                [required]="true"
                (objectChange)="onHostingPlatformChange($event)"
              ></micro-select-pagination>
            </td>
          </tr>
          <tr>
            <th>
              <micro-valid-label
                for="classCodeName"
                [model]="classCodeName"
                label="Class Code"
              ></micro-valid-label>
            </th>
            <td>
              <micro-select-pagination
                apiUrl="/domain/cmdbClassCodes"
                [(id)]="networkProfile.classCodeId"
                [defaultOption]="selectedClassCode"
                placeholder="Class Code"
                [required]="true"
                (objectChange)="onClassCodeChange($event)"
              ></micro-select-pagination>
            </td>
          </tr>
          <tr>
            <th>
              <micro-valid-label
                for="subnetName"
                [model]="subnetName"
                label="Subnet"
              ></micro-valid-label>
            </th>
            <td>
              <micro-select-pagination
                apiUrl="/domain/cmdbSubnets"
                [(id)]="networkProfile.subnetId"
                [defaultOption]="selectedSubnet"
                placeholder="Subnet"
                [required]="true"
                (objectChange)="onSubnetChange($event)"
              ></micro-select-pagination>
            </td>
          </tr>
        </tbody>
      </table>
    </form>
  </div>
</div>
